import React, { Component } from 'react';
import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn,
} from 'material-ui/Table';
import { List, ListItem } from 'material-ui/List';
import Grid from '@material-ui/core/Grid';
import Chip from 'material-ui/Chip';
import Build from 'material-ui/svg-icons/action/build';
import Divider from 'material-ui/Divider';
import Moment from 'react-moment';
import { withRouter } from 'react-router-dom';
import AmCharts from "@amcharts/amcharts3-react";
import Loading from '../components/Loading';
import getNumberStyle from '../utils';
import API from '../api/ApiTool';
import ServiceProviderSelector from '../components/ServiceProviderSelector';
import BridgeServiceProviderSelector from '../components/BridgeServiceProviderSelector';
import { number } from 'prop-types';

const NumbersTable = (props) => {
  return (
    <Table selectable={false}>
      <TableHeader>
        <TableRow>
          <TableHeaderColumn>Number</TableHeaderColumn>
          <TableHeaderColumn>Provider</TableHeaderColumn>
          <TableHeaderColumn>Billing</TableHeaderColumn>
          <TableHeaderColumn>Country iso Code</TableHeaderColumn>
          <TableHeaderColumn>Created</TableHeaderColumn>
          <TableHeaderColumn>Lifetime mins used</TableHeaderColumn>
          <TableHeaderColumn>Toll free</TableHeaderColumn>
          <TableHeaderColumn>Status</TableHeaderColumn>
          <TableHeaderColumn>Date deleted</TableHeaderColumn>
          <TableHeaderColumn>Actions</TableHeaderColumn>
        </TableRow>
      </TableHeader>
      <TableBody>
        {props.numbers.map((number, i) =>
          <TableRow key={i}>
            <TableRowColumn>
            {number.primary ? <b>{number.number}</b> : <span>{number.number}</span> }
            </TableRowColumn>
            <TableRowColumn>
                <ServiceProviderSelector                     
                    serviceProvider={number.service_provider} 
                    number={number.number}
                    />
            </TableRowColumn>
            <TableRowColumn>
              <Chip style={getNumberStyle(number.service_provider)}>
                {number.billing_provider}
              </Chip>
            </TableRowColumn>
            <TableRowColumn>
              <div>
                {number.country_iso_code}
                {number.country_iso_code
                  ? <img
                      style={{marginLeft: '5px'}}
                      src={`https://cdn.rawgit.com/hjnilsson/country-flags/master/svg/${number.country_iso_code.toLowerCase()}.svg`}
                      width="22"
                      alt={number.country_iso_code}
                    />
                  : undefined
                }
              </div>
            </TableRowColumn>
            <TableRowColumn>
              <Moment format="YYYY/MM/DD">{number.created}</Moment>
            </TableRowColumn>
            <TableRowColumn>{number.minutes_used}</TableRowColumn>
            <TableRowColumn>
              {number.toll_free ? 'True' : 'False'}
            </TableRowColumn>
            <TableRowColumn>
              {number.deleted
                ? <Chip style={{backgroundColor: 'rgba(244,63,94,0.2)', color: '#f43f5e'}}>
                    {'Deleted'}
                  </Chip>
                : <Chip style={{backgroundColor: 'rgba(34,197,94,0.2)', color: '#22c55e'}}>
                    {'Active'}
                  </Chip>
              }
            </TableRowColumn>
            <TableRowColumn>
              {number.deleted ? <Moment format="YYYY/MM/DD">{number.date_deleted}</Moment> : '-'}
            </TableRowColumn>
            <TableRowColumn>
              <span>
                <Build
                  style={{cursor: 'pointer'}}
                  onClick={()=> window.open(
                    `https://rpt-admin.bblapp.io/bbladmin/bridges/did/${number.id}/`, '_blank'
                  )} />
              </span>
            </TableRowColumn>
          </TableRow>
        )}
      </TableBody>
    </Table>
  );
}

class CompanyDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {},
      numbers: {},
      minsUsed: {},
      owner: {},
      subusers: [],
    };
  }

  componentDidMount() {    
    const id = this.props.id || this.props.match.params.id;

    API.GET(`/accounts/companies/${id}`)
      .then(response => response.json())
      .then(data => this.setState({
        data: data
      }));

    API.GET(`/bridges/dids/?company_id=${id}&limit=200`)
      .then(response => response.json())     
      .then(data => this.setState({
        numbers: data
      }));

    API.GET(`/bridges/bridge/?company_id=${id}&limit=200`)
      .then(response => response.json())     
      .then(data => this.setState({
        numbers: data
    }));

    API.GET(`/accounts/minutes-used/?id=${id}`)
      .then(response => response.json())
      .then(data => this.setState({
        minsUsed: data.data
      }));

    API.GET(`/accounts/subusers/?id=${id}`)
      .then(response => response.json())
      .then(data => this.setState({
        owner: data.data.owner,
        subusers: data.data.subusers,
      }));
  }

  getBridgeTitle(title, lines) {
    let bridgeTitle = title;
    if (lines.length > 1) {
      bridgeTitle = bridgeTitle + " (" + (lines.length - 1) + " tied numbers)"
    }
    return bridgeTitle;
  }

  updateNumbers = (phone_number, service_provider) => {
    console.log("updateNumbers:", phone_number, service_provider)
    let numbers = Object.assign({}, this.state.numbers);
    Object.keys(numbers.results).forEach(function(key) {
      if (numbers.results[key].number === ("+" + phone_number)) {
        console.log("Found " + phone_number, numbers.results[key].service_provider)
        numbers.results[key].service_provider = service_provider;
        console.log("Updated " + phone_number, numbers.results[key].service_provider)
      }
    })
    console.log("old:", this.state.numbers)
    console.log("new:", numbers)
    this.setState({
      numbers: numbers
    })
    
  }

  render() {
    const { data, numbers } = this.state;
    if (Object.keys(data).length === 0 || Object.keys(numbers).length === 0) {
      return (
        <Loading left={this.props.left} />
      );
    }
    const numbersGrouped = numbers.results.reduce(function (r, n) {
      if (n.route_to.title) {
        r[n.route_to.title] = r[n.route_to.title] || [];
        r[n.route_to.title].push(n);
      }
      else {
        r[n.route_to.title] = r[''] || [];
        r[n.route_to.title].push(n);
      }
      return r;
    }, Object.create(null));

    const titles = Object.keys(numbersGrouped);    
    console.log("render", numbersGrouped)

    const config = {
      "type": "serial",
      "theme": "light",
      "dataProvider": this.state.minsUsed,
      "gridAboveGraphs": true,
      "startDuration": 1,
      "plotAreaBorderAlpha": 0.2,
      "graphs": [ {
        "balloonText": "TF Mins Used: <b>[[value]]</b>",
        "bullet": "round",
        "bulletSize": 10,
        "lineThickness": 3,
        "valueField": "tf_mins_used"
      }, {
        "balloonText": "Mins Used: <b>[[value]]</b>",
        "bullet": "round",
        "bulletSize": 10,
        "lineThickness": 3,
        "valueField": "mins_used"
      } ],
      "chartCursor": {
        "categoryBalloonEnabled": false,
        "cursorAlpha": 0,
        "zoomable": false
      },
      "categoryField": "start_date",
      "secondCategoryField": "start_date",
      "categoryAxis": {
        "gridPosition": "middle",
        "gridAlpha": 0.02,
        "tickPosition": "middle",
        "tickLength": 0
      }
    }

    return (
      <div>
        <h1 style={{color: '#e5e7eb', fontFamily: '"Inter", system-ui, sans-serif'}}>
          {data.name}
        </h1>
        <List>
          <ListItem primaryText="Plan "
            secondaryText={data.tariff ? `${data.tariff.description}` : ''} />
          <ListItem primaryText="Minutes used "
            secondaryText={`${data.total_minutes_used}`} />
          <ListItem primaryText="Toll Free Minutes Used "
            secondaryText={`${data.minutes_used_toll_free}`} />
          <ListItem primaryText="Customer Since "
            secondaryText={<Moment format="YYYY/MM/DD">{data.created}</Moment>} />
          <ListItem primaryText="Lifetime Minutes"
            secondaryText={`${data.lifetime_minutes_used}`}/>
          <div style={{fontFamily: '"Inter", system-ui, sans-serif', marginLeft: '15px'}}>
             <p>Users</p>
             <ul>
               <p>Owner: <strong>{`${this.state.owner.first_name} ${this.state.owner.last_name}:`}</strong> {`${this.state.owner.email}`}</p>
               <p>Subusers:</p>
               {this.state.subusers.map((user, i) =>
        	  <ul key={i}><strong>{`${user.first_name} ${user.last_name}:`}</strong> {`${user.email}`}</ul>
               )}
             </ul>
          </div>
        </List>
        <div style={{marginBottom: '15px'}}>
          <a
            style={{cursor: 'pointer', color: '#3b82f6', fontFamily: '"Inter", system-ui, sans-serif', marginLeft: '15px'}}
            onClick={() => this.props.history.push(`/number-search-logs/${this.props.match.params.id}`)}>
            {'Number search logs'}
          </a>
        </div>
        <Divider inset={true} />
        <br />
        <AmCharts.React style={{ width: "100%", height: "500px", marginTop: "20px" }} options={config} />
        <Divider inset={true} />
        <br />
        {titles.map((title, i) =>
          <div key={i} >
            <Grid container spacing={2} style={{backgroundColor: "#1e293b"}}>
                <Grid item xs={12} md={3}>
                <ListItem primaryText="Bridge"
                  secondaryText={`${this.getBridgeTitle(title, numbersGrouped[title])}`} />
                </Grid>
                <Grid item xs={12} md={2}>
                  <BridgeServiceProviderSelector 
                    numbers={numbersGrouped[title]} 
                    bridgeTitle={`${this.getBridgeTitle(title, numbersGrouped[title])}`}
                    updateNumbers={this.updateNumbers}
                  />
                </Grid>
            </Grid>
            <NumbersTable numbers={numbersGrouped[title]} />
            <br />
          </div>          
        )}
      </div>
    );
  }
}

export default withRouter(CompanyDetail);



// WEBPACK FOOTER //
// ./src/pages/CompanyDetail.js